var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5919 5.34542C29.9678 1.97363 25.2217 0.06871 20.2739 0V20.0126L23.5531 39.7031C27.2083 39.0431 30.6075 37.3775 33.3699 34.8928C36.1323 32.4081 38.1487 29.2026 39.193 25.6355C40.2373 22.0684 40.2684 18.2808 39.2826 14.697C38.2969 11.1133 36.3333 7.87511 33.612 5.34542H33.5919Z",
    fill: "#003F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25463 9.06004C1.46553 11.8014 0.375883 14.9403 0.0812524 18.2013C-0.213379 21.4623 0.296006 24.7459 1.56473 27.764L19.6707 19.8213V0C16.3989 0.0529891 13.1897 0.906297 10.323 2.4855C7.45638 4.0647 5.01934 6.32184 3.22445 9.06004H3.25463Z",
    fill: "#0298A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79639 28.3277C2.71817 30.2952 3.92854 32.1139 5.38741 33.7234C7.61207 36.0834 10.377 37.8665 13.4437 38.9187C16.5104 39.971 19.7868 40.2609 22.9905 39.7634L19.7817 20.4253L1.79639 28.3277Z",
    fill: "#0069D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.1d570cc372d4a7cb787271a2a42ef9c8.svg";
export { ForwardRef as ReactComponent };